import axios from "axios";
import qs from "qs";
import baseURL from "./config/baseURL";
import { Loading, Message } from "element-ui";
import router from "../router";

axios.defaults.withCredentials = true;

// axios实例
const instance = axios.create({
	// 请求超时时间
	timeout: 30 * 1000,

	// 通用headers
	headers: {
		"Content-Type": "application/x-www-form-urlencoded",
	},
	withCredentials: true,
	// 项目baseURL
	baseURL,
});

// 请求拦截器
instance.interceptors.request.use(
	(config) => {
		if (
			config.method === "post" &&
			config.headers["Content-Type"] ===
				"application/x-www-form-urlencoded"
		) {
			// 当请求的header为application/x-www-form-urlencoded，请求方式为post时，需要序列化data
			config.data = qs.stringify(config.data);
		}
		return config;
	},
	(err) => {
		return Promise.reject(err);
	}
);

// 响应拦截器
instance.interceptors.response.use(
	(res) => {
		// 请求成功，status为2xx
		if (res.info == "用户不存在" || res.info == "用户Id不能为空") {
			this.$store.commit("SET_ERROR401");
			this.$alert("登录超时，请重新登录?", "提示", {
				confirmButtonText: "确定",
				callback: (action) => {
					router.push("/liveLogin");
					return false;
				},
			});
		} else {
			if (res.data.info != "") {
				Message({
					message: res.data.info,
					type: res.state == "y" ? "success" : "warning",
				});
			}

			return res.data;
		}
	},

	(error) => {
		(error) => {
			console.log("error", error);
			if (error.response.status == 504) {
				Message({
					message: "接口暂时不可用",
					type: "error",
					duration: 5 * 1000,
				});
			} else if (
				error.response.status == 404 ||
				error.response.status == 405
			) {
				Message({
					message: "接口不存在",
					type: "error",
					duration: 5 * 1000,
				});
			} else if (error.response.status == 500) {
				if (error.response.status == 403) {
					Message({
						message: "接口权限不足",
						type: "error",
						duration: 5 * 1000,
					});
				} else if (error.response.status == 401) {
					store
						.dispatch("Logout")
						.then((res) => {
							if (res.code == "0") {
								if (store.getters.error401 == 0) {
									store.commit("SET_ERROR401");
									this.$alert(
										"登录超时，请重新登录?",
										"提示",
										{
											confirmButtonText: "确定",
											callback: (action) => {
												router.push("/liveLogin");
												return false;
											},
										}
									);
								}
							} else {
								Message({
									message: res.msg,
									type: "error",
									duration: 5 * 1000,
								});
							}
						})
						.catch((error) => {
							console.log(error);
						});
				} else if (
					error.response.status == 401 &&
					store.getters.error401 >= 1
				) {
					console.log("401超时", store.getters.error401);
				} else {
					Message({
						message: error.response,
						type: "error",
						duration: 5 * 1000,
					});
				}

				return Promise.reject(error);
			}
		};
	}
);

// function responseStatusHandle(code) {}

export default instance;
